import {push} from "connected-react-router";
import {DOCUMENT_ROUTE} from "../components/Root/routes";

const showDocument= () => async (dispatch) =>
{
    dispatch(push(DOCUMENT_ROUTE));
};
export default showDocument;